import { render, staticRenderFns } from "./V2ActivePlanCard.vue?vue&type=template&id=0980ddb7"
import script from "./V2ActivePlanCard.vue?vue&type=script&lang=ts"
export * from "./V2ActivePlanCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DLabel: require('/build/apps/legacy/components/Dependencies/Base/DLabel.vue').default,ZButton: require('/build/apps/legacy/components/zeal/ZButton/ZButton.vue').default,ZIcon: require('/build/apps/legacy/components/zeal/ZIcon/ZIcon.vue').default,ZMenu: require('/build/apps/legacy/components/zeal/ZMenu/ZMenu.vue').default,UIButton: require('/build/apps/legacy/components/Common/UI2/Buttons/UIButton.vue').default,V2FeatureSectionHeader: require('/build/apps/legacy/components/Billing/V2/V2FeatureSectionHeader.vue').default})
